import { cn } from '@/lib/utils';
import { FulfillmentCarrier, FulfillmentMethod } from '@/types/fulfillment-type';
import React from 'react';

const METHOD_LABELS: Partial<Record<FulfillmentMethod, string>> = {
  [FulfillmentMethod.PICKUP]: 'Pickup',
  [FulfillmentMethod.DELIVERY_CITY]: 'Delivery (City)',
  [FulfillmentMethod.DELIVERY_PROVINCE]: 'Delivery (Province)',
};

const CARRIER_LABELS: Partial<Record<FulfillmentCarrier, string>> = {
  [FulfillmentCarrier.VIREAK_BUNTHAM]: 'Vireak Buntham',
  [FulfillmentCarrier.JNT]: 'J&T',
};

export function methodLabel(method: FulfillmentMethod) {
  return METHOD_LABELS[method] ?? method;
}

export function carrierLabel(carrier: FulfillmentCarrier | string) {
  return CARRIER_LABELS[carrier as FulfillmentCarrier] ?? carrier;
}

export function formatPrice(price: string | number | null | undefined) {
  if (!price) return '$0.00';
  const amount = typeof price === 'string' ? parseFloat(price) : price;
  if (Number.isNaN(amount)) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function isDeliveryMethod(method?: FulfillmentMethod | null) {
  return method === FulfillmentMethod.DELIVERY_CITY || method === FulfillmentMethod.DELIVERY_PROVINCE;
}

export function SmallInfoTile({
  icon,
  label,
  value,
  mono,
}: {
  icon: React.ReactNode;
  label: string;
  value: string;
  mono?: boolean;
}) {
  return (
    <div className="flex items-start gap-2 rounded-md border border-slate-100 bg-slate-50/60 px-2.5 py-2">
      <div className="mt-0.5 shrink-0">{icon}</div>
      <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-wide text-slate-500">{label}</p>
        <p className={cn('truncate text-xs font-medium text-slate-800', mono && 'font-mono')}>{value}</p>
      </div>
    </div>
  );
}
